import { AxiosResponse } from 'axios';

import { KnowledgeBaseData } from '../../modules/knowledgeBaseV2/knowledgeBaseV2.types';
import { phpApi } from '../default';

export const getThumbnailListsAndTags: () => Promise<KnowledgeBaseData>
= (): Promise<KnowledgeBaseData> => phpApi.get('/api/v2/learning').then(
  (response: AxiosResponse<KnowledgeBaseData>): KnowledgeBaseData => response.data);
